export default {
  root: ({ context, props, parent, instance }) => ({
    class: [
      'w-full',
      // Font
      'leading-none',

      // Spacing
      'm-0',
      'py-2 px-3',
      {
        '!pt-5 !pb-2': parent.instance?.$name === 'FloatLabel',
        '!py-3':
          !instance?.$data.d_value && parent.instance?.$name === 'FloatLabel',
      },

      // Shape
      'rounded-md',

      // Colors
      'text-base-priority bg-base',
      'autofill:!bg-stacked',
      { 'input-style': !context.disabled },
      'border',
      { 'stacked-border': !props.invalid },
      // Invalid State
      {
        'invalid:focus:border-error-500 dark:invalid:focus:border-error-500':
          !!context.filled,
      },
      {
        '!text-dark-800/30 dark:!text-light-700/40 std-border cursor-not-allowed':
          !!context.disabled,
      },
      { 'border-error-500 dark:border-error-500': props.invalid },
      // States
      {
        'focus:outline-none focus:outline-offset-0  focus:border-primary-blue-500 dark:focus:border-primary-blue-400 focus:z-10':
          !context.disabled && !props.invalid,
      },
      'focus:outline-none focus:outline-offset-0 focus:z-10',

      // Filled State *for FloatLabel
      {
        filled:
          parent.instance?.$name == 'FloatLabel' &&
          props.modelValue !== null &&
          props.modelValue?.length !== 0,
      },

      // Misc
      'appearance-none',
      'transition-colors duration-200',
    ],
  }),
};
